import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useDropzone} from 'react-dropzone';
import styled from 'styled-components';

import {setCase} from '../../../features/case.slice';
import fileImport100 from '../../../assets/file-import-solid-cultured.png';
import fileImport50 from '../../../assets/file-import-solid-cultured-50.png';

import styles from '../../../styles/cases/ImportCase.module.scss';
import _axios from '../../../utils/axios';
import { USER } from '../../../utils/settings';

const Wrapper = styled.div`
  &&& {
    ${props => props.isDragActive && 'background-color: rgba(243, 246, 247, 0.1)'};
    
    div {
      background-image: ${props => props.isDragActive ? `url(${fileImport100})` : `url(${fileImport50})`};
    }
    
    &&&:hover div {
      background-image: url(${fileImport100});
    }
    
    p:first-of-type {
      display: ${props => props.isDragActive ? 'block' : 'none'}
    }

    p:last-of-type {
      display: ${props => props.isDragActive ? 'none' : 'block'}
    }
  }
`;

function ImportCase(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // TODO move the libcase/api.js to a more global level, make it more generic and use that
  const importCaseInDB = async ({name, nodes, edges}) => {
    try {
      const putData = {name, nodes, edges};
      const serverResponse = await _axios.put(USER.CASES_PATH, putData);
      const {data, ok, error} = serverResponse.data;
      if (!ok) throw new Error("Server failed to save case: " + (error || 'unknown error'));
      return data;
    } catch(error) {
      let errorMsg = error.response?.data?.error || error.message || '' + error;
      throw new Error(errorMsg);
    }
  }

  const {getRootProps, getInputProps, isDragActive} = useDropzone(
    {onDrop: acceptedFiles => {
        const file = acceptedFiles[0];
        const fileReader = new FileReader();
        fileReader.readAsText(file, 'UTF-8');
        fileReader.onabort = () => console.log('file reading was aborted');  // TODO
        fileReader.onerror = () => console.log('file reading has failed');  // TODO
        fileReader.onload = event => {
          const _case = JSON.parse(fileReader.result);
          const caseName = new Date().toISOString().slice(0, 10) + '_imported__' + _case.name
          importCaseInDB({..._case, name: caseName})
            .then((data) => {
              navigate('/case/' + caseName);
            })
            .catch((err) => {
              alert("Error importing case: " + err);
            })
        }
      }}
  );
  
  return (
    <div className={styles.importCase + ' ' + props.className}>
      <h2>Import a case</h2>
      <Wrapper className={styles.wrapper} isDragActive={isDragActive} {...getRootProps()}>
        <input {...getInputProps()} accept='application/JSON'/>
        <div/>

        <p>Drop the JSON file here...</p>
        <p>Drag and drop a JSON file or <span>browse</span></p>
      </Wrapper>
    </div>
  );
}

export default ImportCase;